import { useQuery } from "@apollo/client";
import { withJsonFormsMultiEnumProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getTranslatedText } from "../../../utils/commons";
import getListPartners from "../../partners/graphql/queries/listPartners";
import "./partnerSelect.scss";

const PartnerSelectComponent = (props) => {
  const { t } = useTranslation();
  const { handleChange, label, path, required, visible, data, uischema, enabled } =
    props;

  const [selected, setSelected] = useState(undefined);

  // Fetch active partners
  const { data: listOfPartnersData } = useQuery(getListPartners, {
    variables: { filter: { active: true } },
  });

  // Memoize the list of partners to avoid unnecessary re-renders
  const partners = useMemo(
    () => listOfPartnersData?.listPartners?.items || [],
    [listOfPartnersData]
  );

  // Format options for dropdown
  const formatOptions = useMemo(
    () => (options) =>
      options.map((option) => ({
        id: option.id,
        displayText: option.name,
      })),
    []
  );

  // Initialize selected option if `data` is provided
  useEffect(() => {
    if (data && partners.length) {
      const selectedPartner = formatOptions(partners).find(
        (partner) => partner.id === data
      );
      if (selectedPartner) {
        setSelected([selectedPartner]);
        return;
      }
    }
    setSelected(undefined);
  }, [data, partners, formatOptions]);

  // Handle selection change
  const handleSelectValue = (val) => {
    if (Array.isArray(val) && val.length > 0) {
      setSelected(val);
      handleChange(path, val[0]?.id ?? null);
    } else {
      setSelected(undefined);
      handleChange(path, null);
    }
  };

  // Return dropdown component if visible
  return visible ? (
    <div
      className={`partner-select-component multiple-select-wrap ${uischema?.options?.className || ""}`}
    >
      <Dropdown
        childList={formatOptions(partners)}
        selection="single"
        label={getTranslatedText(t, label, label)}
        disabled={
          enabled === false ||
          uischema?.readOnly ||
          uischema?.readonly ||
          uischema?.disabled ||
          uischema?.options?.readonly ||
          uischema?.options?.disabled
        }
        selectedValue={selected}
        isRequired={required}
        setSelectedValue={handleSelectValue}
        placeholder={getTranslatedText(
          t,
          uischema?.placeholder,
          uischema?.placeholder
        )}
      />
    </div>
  ) : null;
};

export const PartnerSelectControl = withJsonFormsMultiEnumProps(
  PartnerSelectComponent
);
